// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"78":"e5d3903d","330":"a891943f","515":"c48a6cbf","558":"f06fbc7d","719":"04c2fde7","795":"e5fbced1","901":"50c37b6d"}[chunkId] + ".chunk.css";
};